const SEEN_PREFIX = 'wk_exp_seen:';

function gtag(...args) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
}

export function recordExposure(name, variant) {
  const key = `${SEEN_PREFIX}${name}`;
  try {
    if (localStorage.getItem(key) === variant) return;
    localStorage.setItem(key, variant);
  } catch (e) { /* noop */ }
  gtag('event', 'experiment_exposure', {
    experiment_name: name,
    experiment_variant: variant,
  });
}

export function trackExperiment(name, variant, event, params = {}) {
  let seen = null;
  try { seen = localStorage.getItem(`${SEEN_PREFIX}${name}`); } catch (e) { /* noop */ }
  if (seen !== variant) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(`trackExperiment("${name}") called before exposure was recorded — dropped.`);
    }
    return;
  }
  gtag('event', event, {
    ...params,
    experiment_name: name,
    experiment_variant: variant,
  });
}
